<template>
<article>
  <div class="lz-drawer__body">
    <!-- Form 视图 -->
    <div class="form-section">
      <el-form class="lz-form--block" ref="form" label-width="83px" :model="formData" :rules="rules">
        <el-row>
          <el-col :span="8">
            <el-form-item :label="$t('名称：')" prop="roleName">
              <el-input v-model="formData.roleName" maxlength="50" show-word-limit :placeholder="$t('请输入角色名称')"></el-input>
            </el-form-item>
          </el-col>

<!--          <el-col v-if="isRoleTypeHotel" :span="8">-->
<!--            <el-form-item label="绑定酒店：" prop="hotelVid">-->
<!--              <el-input readonly placeholder="请选择酒店" :disabled="true"-->
<!--                :value="formData.hotelName" @focus="handleSelectHotelClick" />-->
<!--            </el-form-item>-->
<!--          </el-col>-->

        </el-row>
      </el-form>
    </div>

    <!-- 左 系统权限选择 -->
    <div :class="['pt-20', 'permission-section', { 'multi-rows': isRoleTypeHotel }]">
      <SelectPermission ref="PermRef" :roleType="formData.roleType" :hotelVid="formData.hotelVid"></SelectPermission>
    </div>
  </div>

  <div class="lz-drawer__footer lz-drawer__footer__line">
    <el-button type="primary" class="lz-drawer__footer__button confirm" @click="handleSaveClick">{{$t('确定')}}</el-button>
    <el-button class="lz-drawer__footer__button cancel" @click="handleCloseClick()">{{$t('取消')}}</el-button>
  </div>

  <!-- 绑定酒店 -->
  <lz-modal width="586px" loading-enable footer-hide name="select-hotel" :title="modalConfig.title" :mask-closable="false" :loading="modalLoading" v-model="showModal">
    <div slot="body" style="height: 580px;">
      <SelectHotel refer="role" :hotelVid="formData.hotelVid" :hotelName="formData.hotelName" @loading="(loading) => { modalLoading = loading }" @confirm="handleSelectHotelCallback" v-model="showModal" v-if="showModal"></SelectHotel>
    </div>
  </lz-modal>

  <!-- 退出提示视图 -->
  <lz-dialog :title="$t('是否退出编辑？')" :content="$t('当前角色设置内容有变化，是否确定退出编辑？')" :confirmButtonText="$t('继续编辑')" :cancelButtonText="$t('仍然退出')" v-model="showDialog" @confirm="handleDialogButtonClick('cancel')" @cancel="handleDialogButtonClick('confirm')"></lz-dialog>
</article>
</template>

<script>
import { intl } from "@tci18n/vue2";import { mapGetters } from 'vuex';
import fetchMixin from './mixins/fetch';
import SelectHotel from '../common/selectHotel.vue';
import SelectPermission from './permission/index.vue';

// “角色类型”常量
const ROLE_TYPE_GENERAL = 'GENERAL_ROLE';
const ROLE_TYPE_HOTEL = 'HOTEL_ROLE';

export default {
  name: 'RoleEdit',
  mixins: [fetchMixin],
  components: {
    SelectPermission,
    SelectHotel
  },
  props: {
    id: Number, // 角色 id
    action: { // 操作类型（1-新增，2-编辑, 3-复制）
      type: Number,
      default: 1
    },
    hotelData: Object // 酒店角色对应的酒店数据
  },
  data() {
    return {
      formData: {
        roleId: -1,
        roleName: '',
        roleLevel: '',
        roleType: '',
        hotelVid: '',
        hotelName: ''
      },
      originalData: null, // 原始角色数据

      rules: {
        roleName: [
        { required: true, whitespace: true, message: intl.$t("请输入角色名称"), trigger: 'blur' },
        { type: 'string', max: 50, message: intl.$t("角色名称不能超过50位"), trigger: 'click' }],


        roleLevel: [
        { required: true, type: 'number', message: intl.$t("请选择角色级别"), trigger: 'change' }],


        roleType: [
        { required: true, type: 'string', message: intl.$t("请选择角色类型"), trigger: 'change' }],


        hotelVid: [
        { required: true, trigger: 'change', validator: (rule, value, callback) => {
            if (rule.required && (!value || value == 0)) {
              callback(new Error(intl.$t("请选择酒店")));
            } else {
              callback();
            }
          } }]

      },

      roleTypeEnum: [], // “角色类型”数据源
      roleLevelEnum: [], // “角色等级”数据源
      projectData: [], // 项目数据源
      modalLoading: false, // Modal 配置
      showModal: false,
      modalConfig: {
        title: ''
      },
      showDialog: false
    };
  },
  computed: {
    ...mapGetters([
    'isTenantTypeBlocUser']
    ),
    isActionAdd() {// 是否是“新增”操作
      return this.action === 1;
    },

    // 是否是“编辑”操作
    isActionEdit() {
      return this.action === 2;
    },

    // 是否“门店角色”可用
    isRoleTypeHotelEnable() {
      return this.isTenantTypeBlocUser;
    },

    // 当前角色类型是否是“酒店角色”
    isRoleTypeHotel() {
      return this.formData.roleType === ROLE_TYPE_HOTEL;
    },

    // 获取组件引用
    selectPerRef() {
      return this.$refs.PermRef;
    }
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      if (this.hotelData) {
        this.formData.roleType = ROLE_TYPE_HOTEL;
        this.formData.hotelVid = this.hotelData.hotelVid;
        this.formData.hotelName = this.hotelData.hotelName;
      } else {
        this.formData.roleType = ROLE_TYPE_GENERAL;
      }

      this.getRoleTypeSelectList();
      this.getRoleLevelSelectList();
      this.getRoleInfo();
    },

    /**
     * 设置视图 loading 状态
     */
    viewLoading(loading) {
      this.$emit('loading', loading);
    },

    /** 绑定酒店相关 **/
    /**
     * “绑定酒店”点击事件
     */
    handleSelectHotelClick() {
      this.modalConfig.title = intl.$t("分配酒店");
      this.showModal = true;
    },

    /**
     * “绑定酒店”选择回调事件
     * @param { Object } data 选择的数据对象
     */
    handleSelectHotelCallback(data) {
      this.showModal = false;
      if (data.hotelVid !== this.formData.hotelVid) {
        this.formData.hotelVid = data.hotelVid;
        this.formData.hotelName = data.hotelName.trim();
      }
    },

    /** footer 操作按钮相关 **/
    /**
     * Dialog 按钮操作事件
     */
    handleDialogButtonClick(action) {
      if (action === 'confirm') {
        this.handleCloseClick(true);
      } else {
        this.showDialog = false;
      }
    },

    /**
     * 保存点击事件
     */
    handleSaveClick() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let ppData = this.$refs.PermRef.getSelData();

          if (ppData.length > 0) {
            this.saveRole(ppData);

          } else {
            this.$notice.error(intl.$t("请设置角色权限"));
          }
        }
      });
    },

    /**
     * 关闭抽屉事件
     * @param { Boolean } checked 是否已检查
     */
    handleCloseClick(checked = false) {
      if (checked || this.checkBeforeClose()) {
        this.$emit('input', false);
      }
    },

    /**
     * 关闭前校验
     * @returns { Boolean } true/false
     */
    checkBeforeClose() {
      const result = this.checkIfEdit();
      if (result) {
        this.showDialog = true;
      }
      return !result;
    },

    /**
     * 校验是否产生编辑行为
     * @note 系统权限只判断了是否产生编辑行为而非产生实际修改
     * @returns { Boolean } true/false
     */
    checkIfEdit() {
      if (this.$refs.PermRef.checkIfTreeEdit()) {
        return true;
      }
      if (!this.isActionAdd) {

        return this.originalData && (
        this.formData.roleName !== this.originalData.roleName ||
        this.formData.roleType !== this.originalData.roleType ||
        this.formData.roleLevel !== this.originalData.roleLevel);
      } else {
        return this.formData.roleName || this.formData.roleLevel ||
        this.formData.roleType === (this.hotelData ? ROLE_TYPE_GENERAL : ROLE_TYPE_HOTEL) ||
        this.isRoleTypeHotel && this.formData.hotelVid !== this.hotelData.hotelVid;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/const";

.form-section {
  border-bottom: 1px solid $border-color;
}

.permission-section {
  height: calc(100% - 55px);

  &.multi-rows {
    height: calc(100% - 109px);
  }
}
</style>
